// extracted by mini-css-extract-plugin
export var animationContainer = "_ge-0";
export var asteriskIcon = "_ge-8";
export var conversationLeftSection = "_ge-4";
export var conversationListItem = "_ge-3";
export var conversationMiddleSection = "_ge-5";
export var conversationRightSection = "_ge-6";
export var detailsContent = "_ge-1";
export var listContainer = "_ge-7";
export var modalContent = "_ge-2";